export const WILDCARD = "*" as const;
export type Wildcard = typeof WILDCARD;

export type RouteKey =
  | "dashboard"
  | "automations"
  | "campaigns"
  | "calendar"
  | "forms"
  | "audience"
  | "workflows"
  | "onboarding.plan-selection"
  | "onboarding.brand-voice"
  | "account-settings.ai-tuning"
  | "account-settings.profile"
  | "account-settings.plans"
  | "account-settings.sender-details"
  | "account-settings.brand-kit"
  | "account-settings.hero-image"
  | "account-settings.dns";

export type FeatureKey =
  | "dashboard.revenue"
  | "dashboard.tab.overview"
  | "dashboard.tab.revenue"
  | "campaigns.createButton"
  | "campaigns.calendar"
  | "campaigns.statistics"
  | "campaigns.productsInEmail"
  | "campaigns.discount"
  | "automations.createButton"
  | "forms.createButton"
  | "audience.export";

export interface ProviderConfig {
  allowedRoutes: readonly RouteKey[] | Wildcard;
  allowedFeatures: readonly FeatureKey[] | Wildcard;
  allowedAutomations?: readonly string[] | Wildcard;
}
